import { useStyletron } from "baseui";
import { Block } from "baseui/block";
import { ParagraphMedium } from "baseui/typography";
import { useEffect } from "react";
import { useState } from "react";
import { EmptyState } from "../../../../components/EmptyState";
import { IScheduler } from "../types";
import ExceptionsList from "./ExceptionsList";
import { useGetExceptionScheduleQuery, useUpdateExceptionScheduleMutation } from "../../../../services/schedulers";
import { LoadingView } from "../../../../components";
import { convertWeeklySchedule, convertWeeklyScheduleBack } from "../weeklyScheduleConverter";
import { EditableScheduler } from "../EditableScheduler";
import { Button } from "baseui/button";
import { FormattedMessage, useIntl } from "react-intl";
import { useReportMutationState } from '../../../../hooks/useReportMutationState';
import { SpecialEventVm, UpdateExceptionScheduleArgs } from "../../../../services/schedulers/types";
import { GiClick } from "react-icons/gi";

const ExceptionsView = (props: IScheduler) => {
  const [css, theme] = useStyletron();
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);
  const [events, setEvents] = useState<any>();
  const [hasChanges, setHasChanges] = useState(false);
  const intl = useIntl();

  const { data: exceptionSchedule1, isLoading, error, isSuccess } = useGetExceptionScheduleQuery({ resourceGroupId: props.resourceGroupId, objectId: props.id });
  const [update, upateResult] = useUpdateExceptionScheduleMutation();
  useReportMutationState(upateResult);

  const [items, setItems] = useState<SpecialEventVm[]>([]);
  const selectedItem = selectedIndex >= 0 ? items[selectedIndex] : undefined;

  useEffect(() => {
    setItems(exceptionSchedule1 ?? []);
  }, [exceptionSchedule1]);

  useEffect(() => {
    const entries = convertWeeklySchedule(selectedItem?.entries, theme, ['0', '1', '2', '3', '4', '5', '6']);
    setEvents(entries ?? []);
  }, [selectedIndex]);



  useEffect(() => {
    setHasChanges(false);
  }, [upateResult.isSuccess]);

  const handleOnAddItem = (item: SpecialEventVm) => {
    // TODO check if already added
    setItems((old) => {
      const tmp = [...old];
      tmp.push(item);
      return tmp;
    });
    setHasChanges(true);
  }

  return (
    <>
      <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
        {hasChanges && <div className={css({ alignSelf: 'flex-end' })}>
          <Button size='compact' isLoading={upateResult.isLoading} onClick={handleApplyChanges}>
            <FormattedMessage id="applyChanges" defaultMessage="Apply changes" />
          </Button>
        </div>}
        <Block display={'flex'} justifyContent={'space-between'} flexWrap>
          <div className={css({ flex: '0 0 auto' })}>
            <ParagraphMedium>{intl.formatMessage({ id: "Scheduler.ExceptioSchedules", defaultMessage: "Exception Schedules" })}</ParagraphMedium>
            <ExceptionsList onAddItem={handleOnAddItem} selected={selectedItem} app={props} items={items} onItemSelected={handleExceptionScheduleSelected} onDeleteItem={handleDeleteExceptionSchedule}></ExceptionsList>
          </div>
          <div className={css({ flex: '1 1 auto' })}>
            {selectedItem && <>
              <EditableScheduler onEventsChanged={handleEventsChanged} app={props} dataType={props.dataType} events={events} view={'timeGridDay'} ></EditableScheduler>
            </>}
            {!selectedItem &&
              <EmptyState
                icon={<GiClick></GiClick>}
                header={intl.formatMessage({ id: "noItemSelected", defaultMessage: "No item selected" })}
                message={intl.formatMessage({ id: "selectItemFromList", defaultMessage: "Select an item from the list" })}></EmptyState>
            }
          </div>
        </Block>
      </LoadingView>
    </>
  )

  function handleExceptionScheduleSelected(item: any) {
    const index = items.findIndex(x => x === item);
    setSelectedIndex(index);
  }
  function handleEventsChanged(events) {
    const index = selectedIndex
    setItems((old) => {
      const tmp = [...old];
      const oldelm = tmp[index];
      const newElm = {
        ...oldelm,
        entries: convertWeeklyScheduleBack(events)
      };
      tmp[index] = newElm;
      return tmp;
    });
    setEvents(events);
    setHasChanges(true);
  }

  function handleApplyChanges() {

    const cmd: UpdateExceptionScheduleArgs = {
      resourceGroupId: props.resourceGroupId,
      objectId: props.id,
      body: items
    }
    update(cmd);

    setHasChanges(false);
    //alert("not implemented")
  }
  function handleDeleteExceptionSchedule(item: any) {
    const index = items.findIndex((ev) => ev === item);
    setItems((old) => {
      const tmp = [...old];
      tmp.splice(index, 1);
      return tmp;
    });
    setHasChanges(true);
  }


}

export default ExceptionsView;